import { render, staticRenderFns } from "./ShareDetail.vue?vue&type=template&id=3038957e&scoped=true"
import script from "./ShareDetail.vue?vue&type=script&lang=js"
export * from "./ShareDetail.vue?vue&type=script&lang=js"
import style0 from "./ShareDetail.vue?vue&type=style&index=0&id=3038957e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3038957e",
  null
  
)

export default component.exports